/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Stack from '@mui/material/Stack';
import { useTabs } from '@hooks/useTabs';
import { FullpageLoading } from '@components';
// import PageTitle from '@/components/PageTitle';
import { Link } from 'react-router-dom';
// import { PrimaryTabs } from '@components/PrimaryTabs';
import TabPanel from './TabPanel';
// import Empty from './Empty';
import classes from './index.module.css';
// import { billingTabs } from './const';
// import PaymentCard from './PaymentCard';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Page() {
  // const { pathname } = window.location;
  // const [billingTab, setBillingTab] = React.useState(pathname.indexOf('account-settings') > -1 ? 1 : 0);
  const [tabIndex, setTabIndex] = React.useState(0);
  const { tabs, isTabLoading } = useTabs();
  // const navigate = useNavigate();
  const handleChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };
  // const onTabChange = (event, newTabIndex) => {
  //   navigate(newTabIndex ? '/transactions/account-settings' : '/transactions');
  //   setBillingTab(newTabIndex);
  // };

  return isTabLoading ? <FullpageLoading mask /> : (
    <div className={classes.main}>
      {/* <PageTitle title="Billing" /> */}
      {/* <PrimaryTabs tabIndex={billingTab} onTabChange={onTabChange} tabList={billingTabs} /> */}

      <div className={classes.container}>
        {/* placeholder-start */}
        {/* <Stack direction="column" style={{ visibility: 'hidden' }}>
              <Tabs
                orientation="vertical"
                variant="standard"
                sx={{
                  visibility: 'hidden',
                  width: '180px',
                }}
              />
            </Stack> */}
        {/* placeholder-end */}
        <Stack direction="column" style={{ justifyContent: 'flex-start' }}>
          <div className={classes.tabs_header}>Transactions</div>
          <Tabs
            orientation="vertical"
            variant="standard"
            value={tabIndex}
            onChange={handleChange}
            aria-label="transiactions"
            sx={{
              width: '210px',
              '& .MuiTabs-indicator': {
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: '#645AFF',
                height: '30px !important',
                width: '4px',
                left: 0,
                marginTop: '9px',
              },
            }}
          >
            {
              tabs.map((label, index) => (
                <Tab
                  key={label.name}
                  sx={{
                    '&.MuiButtonBase-root': {
                      color: '#252525',
                      fontSize: '14px',
                      fontWeight: 500,
                      alignItems: 'flex-start',
                    },
                  }}
                  style={{ textTransform: 'none' }}
                  label={label.name}
                  {...a11yProps(index)}
                />
              ))
            }
          </Tabs>
        </Stack>
        <Stack
          direction="column"
          sx={{
            width: '100%', alignItems: 'center', position: 'realative', zIndex: 1,
          }}
        >
          <div className={classes.tab_panel_header}>
            {tabs[tabIndex]?.name}
            <Link to="/billing" className={classes.go_back}>Go back</Link>
          </div>
          {
            tabs.map((tab, index) => (
              <TabPanel
                tabIndex={tabIndex}
                tabs={tabs}
                tab={tab}
                index={index}
                key={`panel_${tab.code}`}
              />
            ))
          }
        </Stack>
      </div>

      {/* {billingTab === 1 && (
        <div className={classes.account_settings}>
          <PaymentCard />
          <img className={classes.account_settings_img} src={card} alt="" />
        </div>
      )} */}
    </div>

  );
}
